<template>
  <div class="input-relative">
    <div class="date-picker-relative">
      <v-dialog
        ref="modal_birthday"
        v-model="modal"
        :return-value.sync="internalValue"
        max-width="290px"
        persistent
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
        </template>
        <v-date-picker
          v-model="internalValue"
          :locale="getLocaleDatePicker()"
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="modal = false">
            {{ $t('component.btn-cancle', { split: '/' }) }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="$refs.modal_birthday.save(internalValue)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>

      <v-menu class="v-menu-custom">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="formattedValue"
            :hint="hint"
            class="input-date-picker"
            persistent-hint
            v-bind="attrs"
            @blur="handleDateFromTextField"
            v-on="on"
          ></v-text-field>
        </template>
      </v-menu>
    </div>
    <span
      v-if="validationErrors.required"
      class="form-error-tip"
    >
      {{ $t('validate.required', { split: '/' }) }}
    </span>
    <span
      v-if="validationErrors.format"
      class="form-error-tip"
    >
      {{ $t('validate.date-invalid', { split: '/' }) }}
    </span>
  </div>
</template>

<script>
import {
  HINT_TEXT_DATE_JAPANESE,
  HINT_TEXT_DATE_VIETNAMESE,
  LANG_CODE_JAPANESE
} from '@/common/constants';

export default {
  name: 'BirthdayPicker',
  props: {
    value: {
      type: String,
      required: true
    },
    formattedValue: {
      type: String,
      required: true
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      modal: false,
      internalValue: this.value
    };
  },
  computed: {
    hint() {
      return this.$i18n.locale === LANG_CODE_JAPANESE
        ? HINT_TEXT_DATE_JAPANESE
        : HINT_TEXT_DATE_VIETNAMESE;
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    },
    internalValue(newVal) {
      this.$emit('input', newVal);
      this.updateFormattedValue(newVal);
    }
  },
  methods: {
    getLocaleDatePicker() {
      // Implementation from parent component
      return this.$i18n.locale === LANG_CODE_JAPANESE ? 'ja-jp' : 'vi-vn';
    },

    updateFormattedValue(datetime) {
      if (!datetime) return;
      let string;
      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        const [year, month, day] = datetime.split('-');
        string = year + '/' + month + '/' + day;
      } else {
        const [year, month, day] = datetime.split('-');
        string = day + '/' + month + '/' + year;
      }
      this.$emit('update:formattedValue', string);
    },

    handleDateFromTextField() {
      let string = '';
      const datetime = this.formattedValue;

      if (this.checkDateFormat(datetime)) {
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        } else {
          const [day, month, year] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        }
        this.internalValue = string;
      }
    },

    checkDateFormat(dateString) {
      // Basic date format validation
      const regex = this.$i18n.locale === LANG_CODE_JAPANESE
        ? /^\d{4}\/\d{1,2}\/\d{1,2}$/
        : /^\d{1,2}\/\d{1,2}\/\d{4}$/;
      return regex.test(dateString);
    }
  }
};
</script>
